import {
  Box,
  Button,
  CircularProgress,
  Grid2,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { viewImageOnNewTab } from "../../utils/viewPDF";
import axios from "axios";
import html2pdf from "html2pdf.js";

const ViewEMD = () => {
  const [emd, setEmd] = useState();
  const { tenderId } = useParams();
  const vendorId = JSON.parse(localStorage.getItem("vendor"));
  const storedUser = JSON.parse(localStorage.getItem("user"));
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const pdfRef = useRef();

  const handleExportPDF = () => {
    const pdfContainer = pdfRef.current;

    // Add a class for PDF-specific styling
    pdfContainer.classList.add("pdf-mode");

    html2pdf()
      .from(pdfContainer)
      .set({
        margin: 10,
        filename: "EMD_Details.pdf",
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2, useCORS: true },
        jsPDF: { format: "a4", orientation: "portrait" },
      })
      .save()
      .then(() => {
        // Remove the PDF-specific class after export
        pdfContainer.classList.remove("pdf-mode");
      });
  };

  useEffect(() => {
    const getEMD = async () => {
      try {
        const res = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/vendor-emd/get-by-id?vendorId=${vendorId}&tenderId=${tenderId}`,
          { headers: { Authorization: `Bearer ${storedUser.accessToken}` } }
        );
        setEmd(res.data);
        setIsLoading(false);
      } catch (error) {
        console.error("Error updating vendor status:", error);
      }
    };
    getEMD();
  }, []);
  return (
    <div>
      <div style={{ display: "flex", justifyContent: "end" }}>
        <Button
          className="btn-contained"
          sx={{ width: "200px" }}
          onClick={handleExportPDF}
        >
          Export PDF
        </Button>
      </div>
      {isLoading ? (
        <Box textAlign={"center"}>
          <CircularProgress />
        </Box>
      ) : (
        emd && (
          <Box className="dashboard-container" px={10} py={7} ref={pdfRef}>
            <Typography className="form-title">EMD Information</Typography>
            <Grid2 container>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderTop: "1px solid #000" }}
              >
                UTR Number
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderTop: "1px solid #000",
                  borderRight: "1px solid #000",
                }}
              >
                {emd && emd.utr}
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
              >
                EMD Amount (in &#8377;)
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{
                  borderRight: "1px solid #000",
                }}
              >
                {emd && emd.emdAmount}
              </Grid2>
              <Grid2 size={{ xs: 12, sm: 6 }} className="preview-grid">
                Uploaded Document
              </Grid2>
              <Grid2
                size={{ xs: 12, sm: 6 }}
                className="preview-grid"
                sx={{ borderRight: "1px solid #000" }}
              >
                {emd && emd.document && (
                  <Button
                    sx={{
                      margin: "0 !important",
                      padding: "0 !important",
                      width: "max-content !important",
                      fontSize: "12px !important",
                      textDecoration: "underline",
                      textAlign: "start",
                    }}
                    onClick={() => viewImageOnNewTab(emd.document, storedUser)}
                  >
                    {emd.documentFilename}
                  </Button>
                )}
              </Grid2>
            </Grid2>
          </Box>
        )
      )}
      <Box className="btn-container">
        <Button
          className="btn-outlined"
          onClick={() => navigate(`/vendor/dashboard/${tenderId}`)}
        >
          Back
        </Button>
      </Box>
    </div>
  );
};

export default ViewEMD;
